import {
    Directive,
    Input,
    ViewContainerRef,
    ComponentFactoryResolver,
    ComponentRef,
    OnInit,
    OnDestroy,
    Component
} from '@angular/core';

import { HttpClient } from '@angular/common/http';

// Example DynamicComponent
@Component({
    selector: 'dynamic-html',
    template: ''
})
export class DynamicHtmlComponent {
    @Input() htmlContent: string;
}

@Directive({
    selector: '[mvcPartial]'
})
export class MvcPartialDirective implements OnInit, OnDestroy {
    @Input() url: string;
    @Input() html: string = '<p></p>'; // Default content if no HTML is fetched

    private cmpRef: ComponentRef<any>;

    constructor(
        private vcRef: ViewContainerRef,
        private componentFactoryResolver: ComponentFactoryResolver,
        private http: HttpClient
    ) { }

    ngOnInit() {
        if (this.url) {
            this.http.get(this.url, { responseType: 'text' }).subscribe(
                (html) => {
                    this.html = html || this.html;  // Use the fetched HTML or fallback
                    this.loadDynamicComponent();
                },
                (err) => console.error('Error fetching HTML:', err)
            );
        }
    }

    // Load dynamic component using ComponentFactoryResolver
    private loadDynamicComponent() {
        const factory = this.componentFactoryResolver.resolveComponentFactory(DynamicHtmlComponent);

        // Clear any previous view and create the new component dynamically
        this.vcRef.clear();
        this.cmpRef = this.vcRef.createComponent(factory);

        // Pass the HTML content as input to the dynamic component
        this.cmpRef.instance.htmlContent = this.html;
    }

    ngOnDestroy() {
        if (this.cmpRef) {
            this.cmpRef.destroy();
        }
    }
}
